import { apolloClient } from '~/apollo-client';
import {
  Flex_FetchMembershipPromoCodeQuery,
  Flex_FetchMembershipPromoCodeQueryVariables,
} from '~/typings/graphql';
import { FETCH_MEMBERSHIP_PROMO_CODE } from './fetch-promo-code.queries';

export interface FetchMembershipPromoCodeParams {
  promoCode: string;
  userId: number;
}

export interface FetchMembershipPromoCodeResponse {
  sponsored: boolean;
  sponsoredBy: string;
}

export const fetchMembershipPromoCode = async (
  params: FetchMembershipPromoCodeParams,
): Promise<FetchMembershipPromoCodeResponse> => {
  const { data } = await apolloClient.query<
    Flex_FetchMembershipPromoCodeQuery,
    Flex_FetchMembershipPromoCodeQueryVariables
  >({
    query: FETCH_MEMBERSHIP_PROMO_CODE,
    variables: params,
  });

  return {
    sponsored: !!data.user.signupIncentives?.some(item => item.sponsoredMembership),
    sponsoredBy: data.promoCode.sponsorName ?? '',
  };
};
